import React from "react";

const Iframe = ({ source }) => {
  if (!source) {
    return <div>Loading...</div>;
  }

  const src = source;
  return <iframe className="webmap-full" src={src} width="100%"></iframe>;
};

export default Iframe;
